"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Order() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="17994" id="ready-to-order" className="relative overflow-hidden bg-background py-28 md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[520px] w-[520px] md:h-[720px] md:w-[720px] rounded-lg opacity-[0.15] blur-3xl animate-[glowDrift_20s_ease-in-out_infinite]" style={{
        background: "radial-gradient(closest-side, hsl(228 69% 40% / 0.3), hsl(215 27% 62% / 0.2) 45%, transparent 75%)"
      }} />
      </div>

      <div className="relative mx-auto max-w-[640px] px-6 md:px-10 text-center">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-4 blur-md"}`}>
          <h2 className="font-default text-primary" style={{
          fontWeight: 700,
          fontSize: "clamp(2rem, 4vw, 3.5rem)",
          letterSpacing: "-0.028em",
          lineHeight: 1.04
        }}>
            Ready to{" "}
            <span className="font-default italic" style={{
            fontWeight: 400,
            letterSpacing: "-0.01em"
          }}>order</span>
            ?
          </h2>

          <p className="mt-6 font-default text-foreground" style={{
          fontWeight: 400,
          fontSize: "clamp(1.05rem, 1.15vw, 1.25rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.55
        }}>
            Secure your NoMoCo Pillow Support System today. Our team is ready to assist your facility with your order request.
          </p>

          <div className="mt-10 flex justify-center">
            <a href="/order/" className="w-full sm:w-auto h-auto rounded-md bg-primary px-7 py-3.5 text-base font-bold text-primary-foreground shadow-md hover:bg-primary/90 hover:scale-[1.02] transition-all duration-200 ease-out" style={{
            letterSpacing: "0.05em"
          }}>GET STARTED</a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes glowDrift {
          0%, 100% { transform: translateX(-8%); }
          50% { transform: translateX(8%); }
        }
      `}</style>
    </section>;
}